import { Box, css, Tab, TabList, TabPanels, Tabs, Text, VStack } from '@chakra-ui/react';
import { PropsWithChildren, cloneElement, useEffect } from 'react';
import { useTheme } from '@/pages/Bookstore/contexts/BookstoreThemeAdapter';
import { setBrowserThemeColor } from '@/pages/Bookstore/utils/utils';

export interface ITopBookstoreMenuTab {
  name: string;
  icon: React.JSX.Element;
}

export function TopBookstoreMenu({
  selectedTab = 0,
  tabIndex,
  onTabChange,
  tabs,
  children,
}: {
  selectedTab?: number;
  tabIndex?: number;
  onTabChange?: (index: number) => void;
  tabs: ITopBookstoreMenuTab[];
} & PropsWithChildren) {
  const { colors } = useTheme();

  useEffect(() => {
    setBrowserThemeColor(colors.primaryColor);
  }, [colors]);

  const controlledProps = tabIndex !== undefined
    ? { index: tabIndex, onChange: onTabChange }
    : { defaultIndex: selectedTab };

  return (
    <Box transform={{  lg: 'none' }} minW={'100vw'} maxW={'100vw'}>
      <Tabs isLazy colorScheme="whiteAlpha.900" {...controlledProps}>
        <TabList
          overflowX={{ base: 'hidden', md: 'auto' }}
          minW={'100vw'}
          maxW={'100vw'}
          paddingX={{
            base: 0,
            md: '5%',
          }}
          css={css({
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': { display: 'none' },
            WebkitOverflowScrolling: 'touch',
            border: 'none',
          })}
          paddingBottom={'2px'}
          paddingTop={'10px'}
          backgroundColor={'primaryColor'}
          color="white"
        >
          {tabs.map((tab, i) => (
            <Tab
              key={i}
              _selected={{ border: '0px', borderBottom: '2px solid white', borderRadius: '0px' }}
              marginRight={'0px'}
              flex={{ base: 1, md: 'initial' }}
              minW={{ base: 0, md: 'auto' }}
              w={{ base: 'auto', md: 'fit-content' }}
              padding={{ base: '10px 4px', md: '10px 10px' }}
              paddingBottom={'5px'}
            >
              <VStack spacing={1}>
                {cloneElement(tab.icon, { fontSize: '22px' })}
                <Text
                  fontSize={{
                    base: '12px',
                    md: '16px',
                  }}
                  whiteSpace={'nowrap'}
                  overflow="hidden"
                  textOverflow="ellipsis"
                  maxW="100%"
                >
                  {tab.name}
                </Text>
              </VStack>
            </Tab>
          ))}
        </TabList>

        <TabPanels>{children}</TabPanels>
      </Tabs>
    </Box>
  );
}
